import { Client } from "./Client.model";
import { OrderLine } from "./OrderLine.model";

export class Order {
    id?: number
    orderLines?: OrderLine[];
    orderDate?: Date;
    total?: number;
    discount: number = 0;
    isPaid: boolean = false;
    clientDTO?: Client;
    advancePayment?: number;
    notes?: string;
    hasReturns?: boolean;
    netTotal?: number;
    totalRefunded?: number;
    totalDiscountAdjustment?: number;
    totalAbsorbedFromDebt?: number;

    /**
     * Virtual order: created after the fact to record sales already collected via F8.
     * Virtual orders don't trigger the cash drawer.
     */
    isVirtual: boolean = false;
    
    /**
     * Link to the CashJournal entry (F8) that this virtual order reconciles.
     */
    linkedCashJournalId?: number;
    constructor(
        orderLines?: OrderLine[], 
        orderDate?: Date, 
        discount?: number, 
        isPaid?: boolean, 
        client?: Client, 
        advancePayment?: number, 
        id?: number, 
        notes?: string, 
        isVirtual?: boolean, 
        netTotal?: number, 
        hasReturns?: boolean,
        totalRefunded?: number,
        totalDiscountAdjustment?: number,
        totalAbsorbedFromDebt?: number
    ) {
        this.orderLines = orderLines;
        this.orderDate = orderDate;
        this.total = this.calculateTotal();
        this.discount = discount ?? 0;
        this.isPaid = isPaid?.toString() === 'true' ? true : false;
        this.clientDTO = client;
        this.advancePayment = advancePayment;
        this.id = id;
        this.notes = notes;
        this.isVirtual = isVirtual || false;
        this.netTotal = netTotal;
        this.hasReturns = hasReturns;
        this.totalRefunded = totalRefunded;
        this.totalDiscountAdjustment = totalDiscountAdjustment;
        this.totalAbsorbedFromDebt = totalAbsorbedFromDebt;
    }
    isOrderPaid(): boolean {
        let paid: string = this.isPaid.toString();
        return paid === 'true' ? true : false;
    }
    public calculateTotal(): number {
        if (!this.orderLines) return 0;

        const subtotal = this.orderLines.reduce((sum: number, line: OrderLine) => {
            // Always use realSellingPrice if available, falling back to product price only if necessary
            const price = line.realSellingPrice ?? line.product?.price ?? 0;
            // Use effective quantity (Initial - Returned)
            const quantity = (line.quantity ?? 0) - (line.returnedQuantity || 0);
            const lineTotal = price * quantity;
            return sum + lineTotal;
        }, 0);

        this.total = subtotal;
        return subtotal;
    }


    public setQRCode(): string {
        return "inv-" + this.id;
    }

}